<template>
<moo-popover popper-class="popper-avatar" placement="bottom-end" width="160" v-model="visible" trigger="hover" :close-delay="0">
    <div class="avatar-pop">
      <div class="user-info">
        <div :style="avatarColor" class="user-avatar">
          <span v-if="!data.memberAvatar">
            {{ data.memberName?.slice(-2) }}
          </span>
          <img v-else slot="reference" :src="memberAvatar" class="inner-avatar">
        </div>
        <div class="user-content">
          <div class="user-name">{{ data.memberName }}</div>
          <div class="user-tissue">
            {{ departMentInfo }}
          </div>
        </div>
      </div>
      <moo-popover popper-class="cloud-home-user-card-i18n-popover" trigger="hover" placement="left-start" :offset="-8" :visible-arrow="false" width="180">
        <div slot="reference" class="cloud-home-user-info-card-i18n-setting">
          <svg-icon icon-class="lang_icon" class-name="user-info-card-i18n-icon"></svg-icon>
          <span>{{$t("语言#!!!#src/pages/CloudHome/components/avatar.vue_1")}}</span>
          <svg-icon icon-class="lang_right_arrow" class-name="user-info-card-i18n-right-arrow"></svg-icon>
        </div>
        <div class="user-info-card-i18n-list">
          <div class="i18n-list">
            <div class="i18n-detail" :class="{ 'current': currentLang == item.id }" v-for="(item, index) in i18nList" :key="item.id" @click.stop="handleChangeLang(item)">
              <span>
                {{ item.name }}
              </span>
              <svg-icon v-if="currentLang == item.id" icon-class="lang_current" class-name="i18n-detail-current-icon"></svg-icon>
            </div>
          </div>
        </div>

      </moo-popover>
      <div @click="handleSignOut" class="sign-out">
        <svg-icon class-name="out-icon" icon-class="sign-out"></svg-icon>{{$t("退出登录#!!!#src/pages/CloudHome/components/avatar.vue_1")}}      </div>
    </div>
    <div :style="avatarColor" slot="reference" class="file-avatar">
      <span v-if="!data.memberAvatar"> {{ data.memberName?.slice(-2) }} </span>
      <img v-else slot="reference" :src="memberAvatar" class="file-avatar inner-avatar">
    </div>
  </moo-popover>
</template>

<script>
import { getNameColor } from "@/utils/color";
import { mapState, mapActions } from "vuex";
import { useI18n, intl } from 'tci18n-vue2';
import { switchLang } from '@/utils/lang';

export default {
  props: {
    userInfo: {
      type: Object
    }
  },
  data() {
    return {
      visible: false,
      currentLang: '',
      i18nList: [
      {
        name: intl.$t("简体中文#!!!#src/pages/CloudHome/components/avatar.vue_1"),
        id: 'zh-cn'
      },
      {
        name: intl.$t("英语#!!!#src/pages/CloudHome/components/avatar.vue_1"),
        id: 'en-us'
      }]

    };
  },
  methods: {
    handleSignOut() {
      this.$emit("handleLogOutShow");
    },
    initLang() {
      const { lang } = useI18n();
      this.currentLang = lang;
      if (this.currentLang !== 'zh-cn') {
        this.i18nList.reverse();
      }
    },
    handleChangeLang(lang) {
      if (lang.id !== this.currentLang) {
        this.currentLang = lang.id;
        switchLang(lang.id);
      }
    }
  },
  computed: {
    ...mapState({
      data: (state) => state.currentUserInfo
    }),
    departMentInfo() {
      return this.data.departments?.
      map((item) => item.departmentName).
      join("/");
    },
    avatarColor() {
      return {
        background: getNameColor(this.data.memberName)
      };
    },
    memberAvatar() {
      return this.data.memberAvatar;
    }
  },
  created() {
    this.initLang();
  },
  mounted() {}
};
</script>

<style lang="scss">
.file-avatar {
  cursor: pointer;
  border-radius: 4px;
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 4px;
  width: 26px;
  height: 26px;

  span {
    width: 26px;
    height: 26px;
  }
}

.inner-avatar {
  margin: 0 !important;
  width: 100%;
  height: 100%;
  flex-shrink: 0;
}

.avatar-pop {
  width: 280px;
  height: auto;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  box-shadow: 0 8px 12px 0 #1213171a;
  border-radius: 8px;
  display: flex;
  flex-flow: column;
  align-items: flex-start !important;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;

  .sign-out {
    margin-top: 4px;
    margin-right: 16px;
    width: 248px;
    height: 40px;
    border-radius: 8px;
    cursor: pointer;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #222329;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &:hover {
      background: #f4f6f9;
    }

    .out-icon {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }

  .user-info {
    display: flex;
    flex-flow: row;

    .user-avatar {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      margin-right: 14px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: "PingFang SC", sans-serif;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0;

      img {
        border-radius: 8px;
      }
    }

    .user-content {
      display: flex;
      flex-flow: column;

      .user-name {
        font-family: "PingFang SC", sans-serif;
        font-weight: 600;
        font-size: 17px;
        color: #121317;
        line-height: 24px;
      }

      .user-tissue {
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: #646573;
      }
    }
  }
}

.popper-avatar {
  width: 280px !important;
  height: 140px !important;
  padding: 0 !important;
  /* left: 445px !important; */
  box-sizing: border-box;
  border-radius: 8px !important;
  margin-top: 8px !important;

  .popper__arrow {
    display: none !important;
  }
}

.cloud-home-user-info-card-i18n-setting {
  margin: 16px 16px 0 0px;
  width: 248px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 8px;
  cursor: pointer;

  span {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #222329;
    line-height: 20px;
    display: flex;
    flex: 1;
  }

  &:hover {
    background: #F4F6F9;
  }

  .user-info-card-i18n-icon {
    width: 20px;
    height: 20px;
    margin: 0 8px;
  }

  .user-info-card-i18n-right-arrow {
    width: 14px;
    height: 14px;
    margin-right: 8px;
  }
}

.cloud-home-user-card-i18n-popover {
  width: 180px;
  height: 88px;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  box-sizing: border-box;
  box-shadow: 0 8px 12px 0 #1213171a;
  border-radius: 8px;
  display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 !important;

  .user-info-card-i18n-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .i18n-list {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .i18n-detail {
        height: 40px;
        width: 172px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        border-radius: 8px;

        span {
          margin-left: 8px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #222329;
          letter-spacing: 0;
          flex: 1;
        }

        &:hover {
          background: #F4F6F9;
        }

        &.current {
          color: #5C70FF;
        }

        .i18n-detail-current-icon {
          width: 12px;
          height: 12px;
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
